import type { FC, ReactNode } from 'react'
import type { LayoutProps } from '@/types'

import { MobileCallBar } from '@/components/generals/mobile-call-bar'
import { SiteFooter } from '@/components/generals/site-footer'
import { SiteHeader } from '@/components/generals/site-header'

export const Layout: FC<LayoutProps> = ({ children }): ReactNode => {
    return (
        <div className='flex min-h-screen flex-col'>
            <a
                href='#contenu'
                className='sr-only z-50 rounded-md bg-ink px-4 py-3 font-semibold text-chalk focus:not-sr-only focus:fixed focus:left-4 focus:top-4'
            >
                Aller au contenu
            </a>

            <SiteHeader />

            <main id='contenu' className='flex-1'>
                {children}
            </main>

            <SiteFooter />
            <MobileCallBar />
        </div>
    )
}
